import AVAILABLE_LOCALES from 'utils/locales';
import useTranslationWithFallback from './use-translation-with-fallback';

// Constants


const useLocaleOptions = () => {
  const { t } = useTranslationWithFallback('common');

  return Object.keys(AVAILABLE_LOCALES).map((localeKey) => {
    const text = t(AVAILABLE_LOCALES[localeKey]?.labelTranslation);

    return {
      text,
      value: localeKey
    };
  });
};

export default useLocaleOptions;
